import { X } from "lucide-react";
import { Dispatch, SetStateAction } from "react";
import { GlobalFilter } from "../types/appSession.type";
import { CalendarRangeFilter } from "./CalendarRangeFilter";

interface Props {
  filters: GlobalFilter | undefined;
  setFilters: Dispatch<SetStateAction<GlobalFilter | undefined>>;
}

export function AppSessionFilters({ filters, setFilters }: Props) {
  const hasFilterApplied =
    filters?.startDate || filters?.endDate || filters?.excludeMe;

  return (
    <div className="flex justify-end items-center gap-x-2">
      {hasFilterApplied && (
        <button
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground px-4 py-2 h-8"
          onClick={() => setFilters(undefined)}
        >
          <X className="mr-2 h-4 w-4" />
          Clear all filters
        </button>
      )}
      <button
        className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground px-4 py-2 h-8"
        onClick={() => {
          setFilters((p) => ({
            ...p,
            excludeMe: !p?.excludeMe
          }));
        }}
      >
        <input
          type="checkbox"
          checked={!!filters?.excludeMe}
          readOnly
          className="mr-2 cursor-pointer"
        />
        Exclude my sessions
      </button>
      <CalendarRangeFilter
        selectedDate={filters?.startDate}
        updateDate={(startDate) => setFilters((p) => ({ ...p, startDate }))}
        buttonText="After"
        excludeAfter={filters?.endDate || new Date()}
      />
      <CalendarRangeFilter
        selectedDate={filters?.endDate}
        updateDate={(endDate) => setFilters((p) => ({ ...p, endDate }))}
        buttonText="Before"
        excludeAfter={new Date()}
        excludeBefore={filters?.startDate}
      />
    </div>
  );
}
